module.exports = __webpack_public_path__ + "img/zhaungtai@2x.15f3dc56.png";